<app-card>
  <form [formGroup]="searchForm">
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.dateofwork' | translate }}</label>
          <input appInput type="date" formControlName="dayOfWork">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.meteringpointid' | translate }}</label>
          <input appInput type="text" formControlName="meteringPointIdentification"
                 [placeholder]="'dashboard.timeseries.missing.meteringpointid' | translate">
        </app-input-group>
      </div>
    </div>
    <div>
      <button appButton (click)="table.search()">
        {{ 'common.search' | translate }}
      </button>
    </div>
  </form>
</app-card>

<app-table
  #table
  [config]="tableConfig">
</app-table>

